import { cn } from '@commenda/utils';
import React from 'react';

export interface DataGridCellInputProps {
  children: React.ReactNode;
  hasError?: boolean;
  className?: string;
}

const DataGridCellInput = ({
  children,
  hasError,
  className,
}: DataGridCellInputProps) => (
  <div
    className={cn(
      'flex w-full min-w-0 items-center',
      hasError && 'rounded-sm ring-1 ring-border-error',
      className
    )}
  >
    {children}
  </div>
);

export { DataGridCellInput };
